import { useSelector, useDispatch } from "react-redux";
import { Notification, STATUS_TYPES } from 'dyl-components';
import customersActions from "../../actions/customers";
import contactActions from 'actions/contact';
import { CustomGroupUtils } from 'utils';

const useConvertToCustomer = ({ onClose, refresh, pipeline_id }) => {
    const dispatch = useDispatch();

    const { isCreating, pipelineCategories, campaignConvertedOptions, userAuthTimezone } = useSelector(state => ({
        isCreating: state.account.isCreatingAccount ||
            state.account.isLinkingContactsToAccount ||
            state.customers.isCreatingCustomer ||
            state.account.isUpdatingAccount ||
            state.contact.contactBeingUpdated ||
            state.quote.opportunityBeingUpdated,
        pipelineCategories: state.pipeline.categories.map(category => ({
            key: category.id,
            value: category.id,
            text: category.name,
            stages: category.stages?.map(stage => ({
                key: stage.id,
                value: stage.id,
                text: stage.name,
                sequence_id: stage.sequence_id
            })) || []
        })),
        campaignConvertedOptions: state.campaigns.campaignConvertedOptions,
        userAuthTimezone: state.auth.timezone
    }));

    const createCustomer = async ({ account_id, owner_id, data }) => {
        try {
            const category = pipelineCategories.find(category => category.value === Number(data.pipeline));
            const newStage = category?.stages.find(categoryStage => categoryStage.value === Number(data.stage));

            await dispatch(customersActions.createCustomer({
                account_id: account_id,
                owner_id: owner_id ? Number(owner_id) : null,
                campaign_id: campaignConvertedOptions?.map(campaign => campaign.id)?.includes(data.campaign_converted) ? data.campaign_converted : undefined,
                custom_data: {
                    fields: CustomGroupUtils.extractCustomerDetails(data)
                },
                ...(data.stage ? {
                    pipeline_stage_id: Number(data.stage),
                    sequence_id: owner_id ? newStage?.sequence_id || null : null,
                    timezone: userAuthTimezone
                } : {})
            }, pipeline_id ? { pipeline_id } : {}));

            if (owner_id) {
                await dispatch(contactActions.updateContact(Number(owner_id), { influence: 'decision maker' }));
            }

            Notification.alert('Successfully converted to customer!', STATUS_TYPES.SUCCESS);
            onClose();
            if (refresh) {
                return refresh(account_id);
            }
        } catch (e) {
            console.log(e);
            Notification.alert('Failed to convert to customer', STATUS_TYPES.ERROR);
            throw e;
        }
    };

    return {
        isCreating,
        pipelineCategories,
        createCustomer,
        dispatch
    };
};

export default useConvertToCustomer;
